module.exports = {
  entry: './src/apps/spss-purchase-advisor-self-assessment/index.tsx',
  shortcode: 'spss-purchase-advisor-self-assessment',
  title: 'SPSS Purchase Advisor Self Assessment',
  status: 'stable',
  description: 'Allows users to complete self assessment on SPSS product.',
  preview: {
    url: `${process.env.PUBLIC_URL}/storybook/iframe.html?id=widgets-spss-purchase-advisor-self-assessment-components--default&viewMode=story`,
  },
  settingsSchema: {
    type: 'object',
    properties: {
      fields: {
        type: 'object',
        required: ['endDate', 'startDate'],
        properties: {
          startDate: {
            type: 'string',
            title: 'Discount start date. Format: MM-DD-YYYY',
            description:
              'Enter the date when the discount starts. Format MM-DD-YYYY',
            items: {
              type: 'string',
              pattern: '^(d{1,2})-(d{1,2})-(d{4})$',
            },
            examples: [['10-01-2024']],
          },
          endDate: {
            type: 'string',
            title: 'Discount end date. Format: MM-DD-YYYY',
            description:
              'Enter the date when the discount ends. Format MM-DD-YYYY',
            items: {
              type: 'string',
              pattern: '^(d{1,2})-(d{1,2})-(d{4})$',
            },
            examples: [['10-31-2024']],
          },
        },
      },
    },
  },
  useExternalPeerDependencies: ['react', 'react-dom', 'react-intl'],
  additionalCustomProperties: {
    webSegmentPaths: ['/products'],
    availableTranslations: [
      'de',
      'en',
      'es',
      'fr',
      'it',
      'ja',
      'ko',
      'pt',
      'zh-cn',
      'esla',
    ],
    org: 'digitalsales', // to filter the widget
    brand: 'dataai', // automation, dataai, security, storage, sustainability, other
    widgetLocation: '/pricing', // default '/pricing' but sometimes '/'
    productName: 'spss-statistics', // the product name in the URL
    activatedCountryPages: [
      'us-en',
      'cn-zh',
      'br-pt',
      'de-de',
      'es-es',
      'fr-fr',
      'id-id',
      'it-it',
      'jp-ja',
      'kr-ko',
      'mx-es',
    ],
  },
};
